<template>
  <div>
    <Clientes />
  </div>
</template>
<script>
import Clientes from "@/components/Clientes.vue";

export default {
  components: {
    Clientes
  }
};
</script>
